export default "__VITE_ASSET__BWcL4vTr__"